import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../../services/common/common.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import Swal from "sweetalert2";

import { environment } from "../../../environment/environment";
import { HttpClient } from "@angular/common/http";
// Import DataTables types

@Component({
  selector: "app-spare-part-details",
  templateUrl: "./spare-part-details.component.html",
  styleUrls: ["./spare-part-details.component.css"],
})
export class SparePartDetailsComponent implements OnInit {
  employeeList = [];
  users: any;
  id: any;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: DataTables.Settings = {};

  @ViewChild(DataTableDirective)
  datatableElement!: DataTableDirective;
  project_no: any;
  customerName: any;
  priceValidityTill: any;

  proposalFrm: any = [];
  submitted: any;
  url: any;
  customerActionLogsId: any;
  sparePartsResultDataExist: any;
  ProjectNo: any;
  constructor(
    private commonService: CommonService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.sparePartsResultDataExist = true;
    this.customerActionLogsId = localStorage.getItem("customerActionLogsId");
    if (localStorage.getItem("customerId") == null) {
      this.router.navigate(["/login"]);
    }
    this.route.params.subscribe((params) => {
      console.log("params id",params["id"]);
      this.ProjectNo = environment.projectName;
      this.customerName = "";
      this.priceValidityTill = "";
      this.id = params["id"];
      this.url =
        environment.url +
        "/customers/masters/downloadSparePartsDetails?id=" +
        this.id +
        "&customerActionLogsId=" +
        this.customerActionLogsId;
      this.loadComponentData();
    });
    this.proposalFrm = this.createCountryForm();
    this.proposalFrm.controls["id"].setValue(this.id);
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      processing: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search Spare Part Detail",
      },
    };
  }
  createCountryForm() {
    return (this.proposalFrm = this._formBuilder.group({
      id: ["", Validators.required],
      emailId: [
        "",
        [
          Validators.required,
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
        ],
      ],
      customerActionsLogsId: [this.customerActionLogsId]
    }));
  }
  loadComponentData(): void {
    const payload = {
      id: this.id,
      customerActionLogsId: this.customerActionLogsId,
    };

    this.commonService.projectSparePartDetails(payload).subscribe(
      (response: any) => {
        const data1 = response.data;
        const sparePartsResult = response.sparePartsResult;

        if (!sparePartsResult) {
          this.sparePartsResultDataExist = false;
        } else {
          this.sparePartsResultDataExist = true;
          this.customerName = sparePartsResult.customerName;
          this.project_no = sparePartsResult.projects?.departments?.name;
          this.priceValidityTill = sparePartsResult.priceValidityTill;

          this.users = data1.map((item: any) => ({
            ...item,
            ...item.item_master,
          }));

          if (this.dtTrigger.closed) {
            this.dtTrigger = new Subject();
          }

          if (this.datatableElement != undefined && this.datatableElement.dtInstance) {
            this.datatableElement.dtInstance.then((dtInstance: any) => {
              dtInstance.destroy(); // Destroy existing DataTable
              this.dtTrigger.next(null); // Trigger DataTable reinitialization
            });
          } else {
            this.dtTrigger.next(null); // Trigger DataTable initialization for the first time
          }
        }
      },
      (error:any) => {
        console.error("Error fetching spare part details:", error);
      }
    );
  }
  
  onDownload() { }
  onSubmit() {
    if (this.proposalFrm.invalid) {
      // Swal.fire("Warning!", "Please enter email id.", "warning");
      this.proposalFrm.markAllAsTouched();
      return;
    }
    this.submitted = true;
    this.proposalFrm.controls["id"].setValue(this.id);
    this.commonService
      .sendMail(this.proposalFrm.value)
      .subscribe(
        (response: any) => {
          this.submitted = false;
          if (response.code == 1) {
            Swal.fire({
              title: "Success!",
              text: response.message,
              icon: "success",
              // timer: 3000, // Time in milliseconds (e.g., 3000 ms = 3 seconds)
              // timerProgressBar: true, // Display a progress bar as the timer counts down
              showConfirmButton: true, // Hide the "OK" button
              allowOutsideClick: false,
            });
            // this.proposalFrm.controls["emailId"].setValue("");
            // Properly reset the email field and form validation state
            this.proposalFrm.controls["emailId"].reset();
            // this.router
            //   .navigateByUrl("/app/refresh", { skipLocationChange: true })
            //   .then(() => {
            //     this.router.navigate(["/dash"]);
            //   });
            return true;
          } else if (response.code == 0) {
            Swal.fire({
              title: "Warning!",
              text: response.message,
              icon: "warning",
              // timer: 3000, // Time in milliseconds (e.g., 3000 ms = 3 seconds)
              // timerProgressBar: true, // Display a progress bar as the timer counts down
              showConfirmButton: true, // Hide the "OK" button
              allowOutsideClick: false,
            });
            return false;
          } else {
            Swal.fire({
              title: "Warning!",
              text: "Someting went worng.",
              icon: "warning",
              // timer: 3000, // Time in milliseconds (e.g., 3000 ms = 3 seconds)
              // timerProgressBar: true, // Display a progress bar as the timer counts down
              showConfirmButton: true, // Hide the "OK" button
              allowOutsideClick: false,
            });
            return false;
          }
        },
        (error) => {
          console.log("failure", error);
          return false;
        }
      );
  }

  ngOnDestroy(): void {
    // Unsubscribe from the dtTrigger to prevent memory leaks
    this.dtTrigger.unsubscribe();
  }
}